import { getUpcomingEventsByRegion } from 'api/cms';
import ReminderCard from 'components/reminder-card';
import Spinner from 'components/spinner';
import { format } from 'date-fns';
import React, { FC, useEffect } from 'react';
import { useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { formatReminderDate } from 'utils/helpers';
import APP_ROUTES from 'utils/routes';
import statusMessages from 'utils/status-messages';
import {
  BottomBorderText,
  ReminderListItem,
  ReminderListStyled,
  Wrapper,
} from './reminder-list.styles';

interface Props {
  region?: string;
}

const ReminderList: FC<Props> = ({ region }) => {
  const currentDate = format(new Date(), 'yyyy-MM-dd');
  const { data, isLoading, isError } = useQuery(
    ['reminders', region, currentDate],
    () => getUpcomingEventsByRegion(region, currentDate)
  );

  useEffect(() => {
    if (isError) {
      toast.error(statusMessages.reminderList.reminderFetchError);
    }
  }, [isError]);

  return (
    <Wrapper>
      {isLoading && <Spinner space={20} />}
      {data && (
        <>
          <ReminderListStyled>
            {data.map(({ startDate, endDate, title, _id }) => (
              <ReminderListItem key={_id}>
                <ReminderCard
                  date={formatReminderDate(startDate, endDate)}
                  title={title}
                  href={`${APP_ROUTES.reminder}/${_id}`}
                />
              </ReminderListItem>
            ))}
          </ReminderListStyled>
        </>
      )}
      {((data?.length === 0 && !isLoading) || isError) && (
        <BottomBorderText>{`No reminders`}</BottomBorderText>
      )}
    </Wrapper>
  );
};

export default ReminderList;
